/* @flow */
import 'core-js/stable';

window.App = {};

require('./register-components');
require('./queue-status');
require('./eventmanager');
require('./debug/version');
require('./debug/rollbar');
